import { Expose } from 'class-transformer';
import { Model } from '@shared/models/model';

export class DriversCounts extends Model {
    @Expose() totalFreelanceDriversCount: number;
    @Expose() totalFleetsDriversCount: number;
    @Expose() downloadedFleetsDriversCount?: number;
    @Expose() downloadedFreelanceDriversCount?: number;
}
